import React from 'react';
import { CircleHelp } from 'lucide-react';
import { useContent } from '../contexts/ContentContext';
import { GuideHelpId, isGuideTopic, openGuideHelp } from '../utils/guideHelp';

export default function GuideHelpButton({ section, source }: { section: GuideHelpId; source?: 'gallery-float' }) {
    const { content, language, t } = useContent();
    const title = isGuideTopic(section) ? content.ui[language].siteGuide.topics[section].title : t(`siteGuide.${section}`);
    const label = t('siteGuide.helpLabel.title', { title });
    return <button type="button" className="lab-help-button" data-guide-help={section} aria-label={label} title={label}
        onClick={event => { event.stopPropagation(); openGuideHelp(section, source); }}><CircleHelp size={20} aria-hidden="true" /></button>;
}
